import { Component, OnInit } from '@angular/core';


import { LanguageService } from './services/language.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResourceService } from './services/resource.service';
import { AuthService } from './shared/guards/auth.service';

import { ModalController } from '@ionic/angular';
import { SigninPopupPage } from './modules/signin-popup/signin-popup.page';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public appPages = [
    { title: 'register', url: '/register', icon: 'person', show: 3 },
    { title: 'experimentalSet', url: 'experiment-set', icon: 'flask', show: 1 },
    { title: 'myBooking', url: 'booking-list', icon: 'calendar-number', show: 2 },
    // { title: 'setting', url: '/setting', icon: 'cog' },
    // { title: 'signIn', url: '/home', icon: 'person', show: 3 },
    { title: 'logout', url: '/logout', icon: 'person', show: 2 },
    // { title: 'logout', url: '/logout', icon: 'person', show: 4 },
    // { title: 'help', url: '/assets/help.pdf', icon: 'help', show: 1 },
  ];

  public labels = ['Notes', 'Reminders'];
  constructor(private languageService: LanguageService, public authService: AuthService, private resourceService: ResourceService, private spinner: NgxSpinnerService,
    private modalCtrl: ModalController) {
    this.languageService.setInitState();

    this.resourceService.showLoadingCall$.subscribe((data) => {
      if (data)
        this.spinner.show();
      else
        this.spinner.hide();
    });


    this.resourceService.showLoginFormCall$.subscribe((data) => {
      if (data)
        this.openModal();
    });
  }

  

  useLanguage(language: string) {
    this.languageService.setLang(language);
  }

  async openModal() {
    const modal = await this.modalCtrl.create({
      component: SigninPopupPage,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
    }
  }


  openHelp(){
    //window.open("/assets/help.pdf", "_blank");
    window.open("/booking/assets/help.pdf", "_blank");
  }
}
